import { UserOnboardingStep, UserRole, UserStatus } from '@addviseo/shared/types';

export const onboardingStepOptions = Object.keys(UserOnboardingStep)
  .filter((el) => !isNaN(Number(el)))
  .map((key) => ({
    label: UserOnboardingStep[key as keyof typeof UserOnboardingStep],
    value: Number(key),
  }));

export const roleOptions = [
  { label: 'Administrator', value: UserRole.ADMINISTRATOR },
  { label: 'Beneficiary', value: UserRole.BENEFICIARY },
  { label: 'Advisor', value: UserRole.ADVISOR },
];

export const statusOptions = [
  { label: 'Active', value: UserStatus.ACTIVE },
  { label: 'Inactive', value: UserStatus.INACTIVE },
];
